import { MenuItem, ModifierDetail, ModifierGroupWrapper } from '@/core/models';

export class ModifierExtractorUtil {
	public static extractModifierDetails(
		menuItem: MenuItem,
		predicate: (modifierDetail: ModifierDetail) => boolean
	): ModifierDetail[] {
		return (menuItem.gruposModificadores ?? [])
			.flatMap((group: ModifierGroupWrapper) => group?.grupoModificador?.detallesmodificadores ?? [])
			.filter(predicate);
	}
}
